
import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  Grid,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Divider,
  CircularProgress,
  Autocomplete,
  Chip,
  Tooltip,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Description as FileIcon } from "@mui/icons-material";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { useLocation } from "react-router-dom";

const IssueNoteOutward = ({data}) => {
 const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };


    const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Box>
      <ToastContainer position="top-right" autoClose={3000} />


        <TableContainer
          component={Paper}
          id="item-table"
          sx={{
            maxHeight: "48vh",
            overflowX: { xs: "auto", sm: "unset" },
            overflowY: "auto",
            width: "100%",
          }}
        >
          <Table
            stickyHeader
            size="small"
            sx={{
              minWidth: "max-content",
              "& td, & th": {
                borderBottom: "1px solid #ccc",
                textAlign: "center",
                whiteSpace: "nowrap",
              },
            }}
          >
            {/* ========== TABLE HEAD ========== */}
            <TableHead
              sx={{
                "& th": {
                  fontWeight: "bold",
                  color: (theme) =>
                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                },
              }}
            >
              <TableRow>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 0,
                    backgroundColor: "#f5f5f5",
                    zIndex: 3,
                    minWidth: 50,
                    padding: "8px",
                  }}
                >
                  S. No.
                </TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Req. Slip No</TableCell>
                <TableCell>Division</TableCell>

                <TableCell>Category</TableCell>
                <TableCell>Sub Category</TableCell>
                <TableCell>Item Type</TableCell>
                <TableCell>Item Name</TableCell>
                <TableCell align="right">Qty Issued</TableCell>
                <TableCell>Unit</TableCell>
               
               
              </TableRow>
            </TableHead>

            {/* ========== TABLE BODY ========== */}
            <TableBody>
              { data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center" sx={{ py: 8 }}>
                    <CircularProgress size={40} />
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      Loading data...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center" sx={{ py: 8 }}>
                    <Box>
                      <Typography variant="h6" color="text.secondary">
                       No Data Found
                      </Typography>
                    
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {(() => {
                    let issueSerialNo = 0; // 🆕 Issue-level serial number

                    return data.flatMap((issue) => {
                      const itemsList = issue.items || [];
                      issueSerialNo++; // 🆕 Increment once per issue

                      return itemsList.map((item, itemIdx) => {
                        const isFirstItem = itemIdx === 0;

                        return (
                          <TableRow
                            key={`${issue.id}-${itemIdx}`}
                            hover
                            sx={{
                              backgroundColor:
                                issueSerialNo % 2 === 0 ? "#fafafa" : "#ffffff",
                              "&:hover": {
                                backgroundColor: "#e3f2fd",
                                "& td": {
                                  backgroundColor: "#e3f2fd !important",
                                },
                              },
                              "& td": {
                                paddingTop: "4px !important",
                                paddingBottom: "4px !important",
                                fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                                whiteSpace: "nowrap",
                                color: (theme) =>
                                  theme.palette.mode === "dark"
                                    ? "white"
                                    : "inherit",
                              },
                            }}
                          >
                            {/* 🆕 Serial Number - Rowspan for first item */}
                            {isFirstItem && (
                              <TableCell
                                rowSpan={itemsList.length}
                                align="center"
                                sx={{
                                  position: "sticky",
                                  left: 0,
                                  backgroundColor:
                                    issueSerialNo % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                  zIndex: 2,
                                  fontWeight: "600",
                                  verticalAlign: "middle",
                                }}
                              >
                                {issueSerialNo}
                              </TableCell>
                            )}

                            {/* Date - Rowspan */}
                            {isFirstItem && (
                              <TableCell
                                rowSpan={itemsList.length}
                                sx={{ verticalAlign: "middle" }}
                              >
                                {formatDate(issue.created_at)}
                              </TableCell>
                            )}

                            {/* Issue No - Rowspan */}
                            {isFirstItem && (
                              <TableCell
                                rowSpan={itemsList.length}
                                sx={{
                                  verticalAlign: "middle",
                                
                                }}
                              >
                                <Tooltip
                                  title={`${itemsList.length} item(s)`}
                                  arrow
                                >
                                  <span>{issue.slip_no}</span>
                                </Tooltip>
                              </TableCell>
                            )}

                            {/* Division - Rowspan */}
                            {isFirstItem && (
                              <TableCell
                                rowSpan={itemsList.length}
                                sx={{ verticalAlign: "middle" }}
                              >
                                {issue.division_name}
                              </TableCell>
                            )}

                       
                            {/* Item Details */}
                            <TableCell>{item.category_name || "-"}</TableCell>
                            <TableCell>
                              {item.sub_category_name || "-"}
                            </TableCell>
                            <TableCell>{item.item_type || "-"}</TableCell>
                            <TableCell>
                              <Tooltip title={item.item_name} arrow>
                                <span>{item.item_name || "-"}</span>
                              </Tooltip>
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: "500" }}>
                              {item.issue_qty || 0}
                            </TableCell>
                            <TableCell>{item.uom_name || "-"}</TableCell>


                            {/* Issued By - Rowspan */}
                            {/* {isFirstItem && (
                              <TableCell
                                rowSpan={itemsList.length}
                                sx={{ verticalAlign: "middle" }}
                              >
                                {issue.created_by_name || "-"}
                              </TableCell>
                            )} */}
                          </TableRow>
                        );
                      });
                    });
                  })()}

                  {/* ========== GRAND TOTAL ROW ========== */}
                 
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
  
    </Box>
  );
}

export default IssueNoteOutward;